import { useMemo } from "react";
import { reduceSharesToAdd } from "./reduceSharesToAdd";
import {
  FolderShare,
  HydratedFolderShare,
  useAccount,
  useMembers,
  useTeams,
} from "@zapier/client";

export function useHydratePendingShares(
  toAdd: FolderShare[],
): HydratedFolderShare[] {
  // Figure out all the pending memberIds and teamIds that are needed to be
  // displayed in the list
  const [memberIdsToAdd, teamIdsToAdd, accountIdsToAdd] = useMemo(() => {
    return reduceSharesToAdd(toAdd);
  }, [toAdd]);

  // Hydrate the members and teams that are pending to be added
  // so they can be previewed in the list
  const { members } = useMembers({ ids: memberIdsToAdd });
  const { teams } = useTeams({ ids: teamIdsToAdd });
  const { account } = useAccount({ enabled: accountIdsToAdd.length > 0 });

  const hydrated = useMemo(() => {
    return toAdd.map((share) => {
      if (share.shareType === "customuser" && members[share.shareId]) {
        return {
          ...share,
          member: members[share.shareId],
        };
      }
      if (share.shareType === "team" && teams[share.shareId]) {
        return {
          ...share,
          team: teams[share.shareId],
        };
      }
      if (account && share.shareType === "account") {
        return {
          ...share,
          account,
        };
      }
      return share;
    });
  }, [toAdd, members, teams, account]);

  return hydrated as HydratedFolderShare[];
}
